import classNames from 'classnames';
import React from 'react';
import { Heading, Logo } from 'ui/components';
import styles from './LoginBox.module.scss';

export interface LoginBoxProps {
	className?: string;
	children?: React.ReactNode;
	heading?: string;
	text?: string;
	logoHref?: string;
}

export const LoginBox: React.FC<LoginBoxProps> = ({
	// className,
	children,
	heading,
	logoHref = '#',
}) => {
	return (
		<div className={classNames(styles.LoginBox)}>
			<Logo className={classNames(styles.LoginBox_logo)} href={logoHref} variant="grey" />
			{heading && (
				<Heading className={classNames(styles.LoginBox_heading)} headingLevel="h3">
					{heading}
				</Heading>
			)}
			{children}
		</div>
	);
};
